import React from 'react';
import { Box, Move, Stagger } from '@razorpay/blade/components';

import { ContractorsInfoCard } from './components/ContractorsInfoCard';
import { AttendanceOptions } from './components/AttendanceOptions';
import { ShiftTracking } from './components/ShiftTracking';
import { WeeklyOff } from './components/WeeklyOff';

interface AttendanceTabProps {
  onNavigateToPayRules?: () => void;
}

export const AttendanceTab = ({ onNavigateToPayRules }: AttendanceTabProps) => {
  return (
    <Stagger
      motionTriggers={['mount']}
      delay="2xquick"
      display="flex"
      flexDirection="column"
      gap="spacing.6">
      <Move>
        <Box>
          <ContractorsInfoCard />
        </Box>
      </Move>

      <Move>
        <Box>
          <WeeklyOff />
        </Box>
      </Move>

      <Move>
        <Box>
          <ShiftTracking onNavigateToPayRules={onNavigateToPayRules} />
        </Box>
      </Move>

      <Move>
        <Box>
          <AttendanceOptions />
        </Box>
      </Move>
    </Stagger>
  );
};
